import { Navigate } from 'react-router';
import { defineProductWeb } from '@lumlab/platform-product/web';
import fr from '../../locales/fr.json' with { type: 'json' };
import { tendersProductId } from '../contract/index.ts';
import { AgenciesPage } from './AgenciesPage.tsx';
import { AdminAgenciesPage } from './AdminAgenciesPage.tsx';
import { ArchiveImportsPage } from './ArchiveImportsPage.tsx';
import { AnalysisArbitrationPage } from './AnalysisArbitrationPage.tsx';
import { AdministrationLayout } from './AdministrationLayout.tsx';

export const tendersWeb = defineProductWeb({
    id: tendersProductId,
    navigation: [{ path: '/tenders/agencies', labelKey: 'tenders.navigation.agencies' }],
    routes: [
        { index: true, element: <Navigate to="agencies" replace /> },
        { path: 'agencies', element: <AgenciesPage /> },
    ],
    catalogs: { fr },
    administration: {
        routes: [
            {
                element: <AdministrationLayout />,
                children: [
                    { index: true, element: <ArchiveImportsPage /> },
                    { path: 'agencies', element: <AdminAgenciesPage /> },
                    { path: 'analysis', element: <AnalysisArbitrationPage /> },
                    { path: 'analysis/:runId', element: <AnalysisArbitrationPage /> },
                ],
            },
        ],
    },
});
